import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Youtube, ArrowRight } from 'lucide-react';
import { useSiteSettings } from '../../context/SiteSettingsContext';
import { legalPageAPI } from '../../services/api';

export default function Footer() {
    const { settings } = useSiteSettings();
    const [legalPages, setLegalPages] = useState([]);

    useEffect(() => {
        legalPageAPI.getAll().then(res => setLegalPages(res.data || [])).catch(() => {});
    }, []);

    return (
        <footer className="footer">
            {/* Top: logo + newsletter hint */}
            <div className="footer-top">
                <div className="footer-top-inner">
                    <img src="/logo_noora.png" alt="Noora Privé" className="footer-logo" />
                    <p className="footer-tagline">Zarafeti keşfedin.</p>
                    <div className="footer-social">
                        {settings.instagram && <a href={settings.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Instagram size={18} /></a>}
                        {settings.facebook && <a href={settings.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><Facebook size={18} /></a>}
                        {settings.youtube && <a href={settings.youtube} target="_blank" rel="noopener noreferrer" aria-label="Youtube"><Youtube size={18} /></a>}
                    </div>
                </div>
            </div>

            {/* Middle: links */}
            <div className="footer-mid">
                <div className="footer-mid-inner">
                    <div className="footer-col">
                        <h5>Mağaza</h5>
                        <Link to="/urunler">Tüm Ürünler</Link>
                        <Link to="/">Yeni Gelenler</Link>
                        <Link to="/urunler">Koleksiyonlar</Link>
                    </div>
                    <div className="footer-col">
                        <h5>Bilgi</h5>
                        <Link to="/hakkimizda">Hakkımızda</Link>
                        <Link to="/iletisim">İletişim</Link>
                        {legalPages.map(page => (
                            <Link key={page.id} to={`/sayfa/${page.slug}`}>{page.title}</Link>
                        ))}
                    </div>
                    <div className="footer-col">
                        <h5>İletişim</h5>
                        {settings.email && <a href={`mailto:${settings.email}`}>{settings.email}</a>}
                        {settings.phone && <a href={`tel:${settings.phone.replace(/\s/g, '')}`}>{settings.phone}</a>}
                    </div>
                </div>
            </div>

            {/* Payment */}
            <div className="footer-payment">
                <img src="/iyzico-footer-band.svg" alt="iyzico ile güvenli ödeme" className="footer-payment-band" />
            </div>

            {/* Bottom */}
            <div className="footer-bottom">
                <span>&copy; {new Date().getFullYear()} Noora Privé</span>
                <span className="footer-sep">·</span>
                <a href="https://megedigital.com" target="_blank" rel="noopener noreferrer">megedigital.com</a>
            </div>
        </footer>
    );
}
